<template>
  <div class="root-container">
    <video-player
      v-show="startPlay"
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      customEventName="customstatechangedeventname"
      @play="onPlayerPlay($event)"
      @playing="onPlayerPlaying($event)"
      @pause="onPlayerPause($event)"
      @statechanged="playerStateChanged($event)"
      @canplay="onPlayerCanplay($event)"
      @ready="playerReadied"
    >
    </video-player>
    <van-image v-if="!startPlay" :src="pic" style="width: 100%" height="260" />
    <van-list v-model="loading" @onLoad="initData" :finished="finished">
      <div
        class="item"
        v-for="(item,index) in list"
        :key="item.coursewareId"
        :title="item.coursewareName"
        @click="onItemClick(item,index)"
      >
        <div class="left">
          <span>{{ item.coursewareName }}</span>
          <span class="content-text">主讲人：{{ item.coursewareTeacher }}</span>
          <span class="content-text"
            >应学时长：{{ item.linkLength / 60 }}分钟</span
          >
        </div>
        <van-icon
          v-if="item.coursewareType == '纯视频课件'"
          size="30"
          color="#3D47B8"
          :name="item.isPlaying ? 'pause-circle-o' : 'play-circle-o'"
        ></van-icon>
        <van-icon
          color="#3D47B8"
          v-if="item.coursewareType == '文档课件'"
          size="30"
          name="description"
        ></van-icon>
        <van-divider />
      </div>
    </van-list>
  </div>
</template>

<script>
import axios from "axios";
import md5 from "js-md5";
import util from "@/utils/util";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
const SCHOOL_APPID = "a1e98a66-94dd-4c15-998d-176e4b0082d6";
const SCHOOL_APPKEY = "MGY3OTk2ZmMyNmMwNDFhYzhhNmE0MzVhZDMxYTkyMjY=";
export default {
  components: {
    videoPlayer,
  },
  data() {
    return {
      startPlay: false,
      loading: true,
      finished: false,
      uId: null,
      courseId: null,
      list: [],
      pic: null,
      playerOptions: {
        // videojs options
        aspectRatio: "400:260",
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        controlBar: true,
      },
    };
  },
  created() {
    this.uId = util.getUrlKey("uId") || "256154";
    this.courseId = util.getUrlKey("courseId") || "299";
    this.pic =
      util.getUrlKey("pic") ||
      "https://el.rrswl.com/Upload/CourseImg/2020032501022390264.jpg";
    this.initData();
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    initData() {
      const form = new FormData();
      form.append("userId", this.uId);
      form.append("courseid", this.courseId);
      // let baseUrl =
      //   process.env.NODE_ENV == "development"
      //     ? "/rrswl"
      //     : "https://el.rrswl.com";
			let baseUrl = '/iapp/'
      const timestamp = parseInt(new Date().getTime() / 1000);
      const sign = md5(SCHOOL_APPID + SCHOOL_APPKEY + timestamp);
      const url = `${baseUrl}study/resource?appid=${SCHOOL_APPID}&sign=${sign}&timestamp=${timestamp}`;
      axios
        .post(url, form, {
          headers: { "content-type": "application/x-www-form-urlencoded" },
        })
        .then((res) => {
          this.loading = false;
          this.finished = true;
          this.list = res.data.ExtendData.coursewareList;
          this.list.forEach((item) => {
            item.isPlaying = false;
          });
        });
    },
    onItemClick(item,index) {
      if (item.coursewareType == "文档课件") {
        window.location.href = item.coursewareUrl;
        return;
      }
      this.startPlay = true;
      this.player.src({ type: "video/mp4", src: item.coursewareUrlv2 });
      this.player.ready(() => {
        this.player.play();
        item.isPlaying = true;
        this.list.forEach((_item,_index) => {
          if (item.coursewareId != _item.coursewareId) {
            _item.isPlaying = false;
            this.$set(this.list, _index, _item);
          }
        });
        this.$set(this.list, index, item);
      });
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player play!', player)
    },
    onPlayerCanplay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    // player is ready
    playerReadied(player) {
      // you can use it to do something...
      // player.[methods]
    },
  },
};
</script>

<style lang="scss" scoped>
.root-containera {
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  position: absolute;
}
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
  padding-right: 8px;
  text-align: left;
  margin-top: 8px;
  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    span {
      font-size: 16px;
    }
    .content-text {
      margin-top: 4px;
      margin-left: 12px;
      color: #888888;
      font-size: 14px;
    }
  }
}
::v-deep .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>